import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { SlidersHorizontal } from "lucide-react";

import {
  getIndustryList,
  getLocation,
  getEmployeeCountList,
  getLeadStatusList,
  getLeadRatingList,
  getLeadTagList,
} from "../../actionCreator/leadListingActionCreater";
import AdvancedFilterModel from "./AdvancedFilterModel";
import AdvancedFilter from "./AdvancedFilter";
import { getClientNotesTags } from "../../actionCreator/leadDetailsActionCreator";

const LeadLeft = () => {
  const dispatch = useDispatch();
  const [menuVisible, setMenuVisible] = useState(true);
  const [openAdvancedModel, setOpenAdvancedModel] = useState({
    open: false,
    key: 0,
  });

  useEffect(() => {
    dispatch(getLeadStatusList());
    dispatch(getLeadRatingList());
    dispatch(getIndustryList());
    dispatch(getLocation());
    dispatch(getEmployeeCountList());
    dispatch(getLeadTagList());
    dispatch(getClientNotesTags());
  }, [dispatch]);

  const openLeftMenu = () => {
    setMenuVisible(!menuVisible);
  };

  const openAdvancedFilter = () => {
    setOpenAdvancedModel({ open: true, key: 0 });
  };

  return (
    <>
      <div className="tw-bg-white tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 tw-mr-4 tw-shadow-sm tw-font-inter tw-overflow-hidden tw-h-[calc(100vh-215px)] tw-flex tw-flex-col">
        <button className="filter-button btn-primary" onClick={openLeftMenu}>
          Filters
        </button>
        <div className={`tw-flex tw-flex-col tw-h-full tw-overflow-hidden ${menuVisible ? "hideLeftMenu" : ""}`}>
          <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-py-4 tw-px-4 tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-b tw-border-solid tw-border-slate-100 tw-shrink-0">
            <span className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-slate-400">
              Filters
            </span>
            <div
              className="tw-cursor-pointer tw-p-1 hover:tw-bg-slate-50 tw-rounded-md tw-transition-colors"
              onClick={openAdvancedFilter}
              title="Advanced Filters"
            >
              <SlidersHorizontal size={16} className="tw-text-slate-500 hover:tw-text-[#5D44FF]" />
            </div>
          </div>

          <div
            className={`leftmenufilter tw-flex-1 !tw-overflow-y-auto`}
          >
            <AdvancedFilter
              openAdvancedModel={openAdvancedModel}
              showCheckAll={false}
              setOpenAdvancedModel={setOpenAdvancedModel}
              showNumberofRecords={9}
            />
          </div>
        </div>
      </div>

      {openAdvancedModel.open && (
        <AdvancedFilterModel
          setOpenAdvancedModel={setOpenAdvancedModel}
          openAdvancedModel={openAdvancedModel}
          showNumberofRecords={36}
        />
      )}
    </>
  );
};

export default LeadLeft;
